// MUI Imports
import type { Theme } from '@mui/material/styles'

/** Prominent table headers app-wide (MUI Table / TableContainer). */
const tableCell: Theme['components'] = {
  MuiTableCell: {
    styleOverrides: {
      head: ({ theme }) => ({
        fontWeight: 700,
        fontSize: '0.75rem',
        letterSpacing: '0.065em',
        textTransform: 'uppercase',
        color: theme.palette.text.primary,
        backgroundColor:
          theme.palette.mode === 'dark' ? theme.palette.grey[900] : theme.palette.grey[100],
        borderBottomWidth: 2,
        borderBottomStyle: 'solid',
        borderBottomColor: theme.palette.divider,
      }),
    },
  },
}

export default tableCell
